import { FC } from 'react';
import { SimpleLabel } from '@hopskipdrive/react-components';

interface IPausedLabel {
  message?: Nullable<string>;
}

export const PausedLabel: FC<IPausedLabel> = ({ message }) => {
  return <>{message && <SimpleLabel label={message} textColor="white" bgColor="warning-main" />}</>;
};
